import {useContext, useEffect, useState} from "react";
import {useAtom} from "jotai";
import classNames from "classnames";
import {Button, Input, message, Select, Tooltip} from "antd";
import {SoftPhoneBar} from "@shj/use-soft-phone";
import ExtenTypeSelect from "@/components/shj-soft-phone/ExtenTypeSelect.tsx";

import clueDetailContext from "@/pages/callTool/intelligentOutboundCall/components/Info/clueDetailContext.ts";
import styles from '../../../index.module.less'
import {callDataAtom, callStateAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";
import {fetchCall, fetchSipCall} from "@/pages/callTool/intelligentOutboundCall/components/Info/store/fn.tsx";
import {CopyOutlined, LoadingOutlined} from "@ant-design/icons";
import {viewPhoneBySource} from "@/services/callCenter";
import {iiHOC} from "@/utils/auth.ts";
import {getLineAllocationList, updateZitongSeatAccount} from "@/services/crmTool.ts";
import {getUser} from "shj-utils";

export const CallBox = props => {
  const user = getUser()
  const {detailInfo = {}, updatePhone} = useContext(clueDetailContext)
  const [isCopyLoading, setIsCopyLoading] = useState<boolean>(false)
  const [callData, setCallData] = useAtom(callDataAtom)
  const [callState, setCallState] = useAtom(callStateAtom)

  useEffect(() => {
      getZhiTongLine()
  }, []);

  useEffect(() => {
   setCallData((callData) => ({...callData, phone: detailInfo.phone || ''}))
  }, [detailInfo.phone]);

  const getZhiTongLine = () => {
    getLineAllocationList({brand: 'ZITONG', orgId: user.companyId}).then(res => {
      setCallState((callState) =>({...callState, zitongLines: res || [], zitongLine: res?.[0]?.line}))
    })
  }

  const onCallUp = () => {
    if (callData.callLine !== 'HELI') {
      fetchSipCall({setCallData, newPhone: callData.phone, detailInfo, callData, callState})
    } else {
      fetchCall({setCallData, newPhone: callData.phone, detailInfo})
    }
  }

  const onChangePhone = (e) => {
    const value = e.target.value || ''
    setCallData((callData) => ({...callData, phone: value}))
    detailInfo.id && updatePhone?.(value)
  }

  const onCopy = () => {
    if (!callData.phone) return message.error('没有可复制内容')
    setIsCopyLoading(true)
    if (detailInfo.id) {
      viewPhoneBySource(detailInfo.id, 'salesWorkBenchClueViewPhone').then((res: string) => {
        navigator.clipboard.writeText(res).then(() => {
          message.success('复制成功');
        });
      }).finally(() => setIsCopyLoading(false))
    } else {
      navigator.clipboard.writeText(callData.phone).then(() => {
        message.success('复制成功');
        setIsCopyLoading(false)
      });
    }
  }

  const onChangeZTLine = (v) => {
    updateZitongSeatAccount({id: callState.zitongId, zitongLine: v}).then(() => {
      setCallState((callState) => ({...callState, zitongLine: v}))
    })
  }

  return <>
  {callData.callLine === 'HELI' ? <div className={classNames([styles.flexBetween, styles.pb10])}>
      <p style={{flex: '0 0 30%'}}>呼叫方式：</p>
      <div style={{flex: '0 0 45%'}}>
        <ExtenTypeSelect onChange={props.onExtenTypeChange} style={{width: '100%'}}/>
      </div>
      <div style={{flex: '0 0 25%'}}></div>
    </div> : null}
    <div className={classNames([styles.flexBetween, styles.pb10])}>
      <p style={{flex: '0 0 30%'}}>外呼服务商：</p>
      <Select placeholder={'请选择外呼服务商'} style={{flex: '0 0 45%'}}
              disabled={callData.disabled} value={callData.callLine}
              options={callState.brandList}
              fieldNames={{label: 'brandName', value: 'brand'}}
              onChange={(v) => {
                setCallData((callData) => ({...callData, callLine: v}))
              }}/>
      <div style={{flex: '0 0 25%'}}></div>
    </div>
  {callData.callLine === 'HELI' ? null : <div className={classNames([styles.flexBetween, styles.pb10])}>
    <p style={{flex: '0 0 30%'}}>线路选择：</p>
    <Select placeholder={'请选择线路选择'} style={{flex: '0 0 45%'}}
            disabled={callData.disabled} value={callState.zitongLine}
            options={callState.zitongLines?.map(item => ({label: item.lineName, value: item.line}))}
            onChange={onChangeZTLine}/>
    <div style={{flex: '0 0 25%'}}></div>
  </div>}
    <div className={classNames([styles.flexBetween, styles.pb10])}>
      <p style={{flex: '0 0 30%'}}>通话号码：</p>
      <Input value={callData.phone} onChange={onChangePhone} placeholder={'请输入电话号码'} style={{flex: '0 0 45%'}}
             maxLength={11}
             suffix={isCopyLoading ? <LoadingOutlined style={{fontSize: 12, color: '#b2b2b2'}}/> : iiHOC(<Tooltip
                 title="复制">
               <CopyOutlined datareskey={'salesWorkBenchClueViewPhone'} onClick={onCopy}
                             style={{fontSize: 12, color: '#b2b2b2'}}/>
             </Tooltip>)}
      />
      <div style={{flex: '0 0 25%'}}>
        <Button loading={callData.loading}
                disabled={!callState.isSeat || callData.disabled || !callData.phone || callData.phone?.length !== 11} type={'primary'}
                style={{marginLeft: 5}} onClick={onCallUp}>呼叫</Button>
      </div>
    </div>
    {callData.callLine === 'HELI' ? <div className={classNames([styles.flexBetween, styles.pb10])}>
      <p style={{flex: '0 0 30%'}}>通话状态：</p>
      <div className={styles.callStatusBox} style={{flex: '0 0 45%'}}>
        <SoftPhoneBar
            extenTypeSelectVisible={false}
            style={{width: '100%', margin: 0}}
        />
      </div>
      <div style={{flex: '0 0 25%'}}></div>
    </div> : null}
  </>
}